/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';

export type ChangeUserRoleErrorProps = {
  currentAccountDetails: Object,
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ChangeUserRoleError extends ComponentWithInjectedProps<
  ChangeUserRoleErrorProps,
  {},
  InjectedProps
> {
  render(): React.Node {
    const { actionDrawerStore, t } = this.props;
    const { errorResponse } = actionDrawerStore;

    const requiresPendingInformation =
      errorResponse && errorResponse.data && errorResponse.data.role_change_request_exists;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:users.change_role_failed')}
          >
            {errorResponse && <p>{errorResponse.message}</p>}
            {requiresPendingInformation && (
              <p>{t('general:users.change_role_requires_approval')}</p>
            )}
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
